import MarkSoldAccordion from "./MarkSoldAccordion"
import Spinner from "../../common/Spinner"
import useStore from "../../../store"

export default function MarkSoldForm() {
  const creatingUnitFile = useStore((state) => state.creatingUnitFile)
  const markingUnitSold = useStore((state) => state.markingUnitSold)

  return(
    <div>
      {(creatingUnitFile || markingUnitSold) ?
        <Spinner/>
      :
        <MarkSoldAccordion />
      }
    </div>
  )
}